// Free Shipping Banner functionality
function getFreeShippingThreshold() {
    const thresholdData = window.free_shipping_threshold;
    
    // Check HTML lang attribute FIRST - this is the source of truth
    const htmlLang = document.documentElement.getAttribute('lang');
    const htmlLangLower = htmlLang ? htmlLang.toLowerCase() : '';
    const htmlLangCheck = htmlLangLower ? htmlLangLower.slice(0, 2) : '';
    
    // Use HTML lang as primary source - ignore Liquid/data attributes if they conflict
    if (htmlLangCheck === 'sv' && thresholdData?.sek) {
        return thresholdData.sek; // 739 for Swedish
    } 
    else if (htmlLangCheck === 'da' && thresholdData?.dkk) {
        return thresholdData.dkk; // 399 for Danish
    }
    
    // Fallback: Check if Liquid already determined it's Swedish (only if HTML lang doesn't work)
    if (thresholdData?.isSwedish === true && thresholdData.sek) {
        return thresholdData.sek;
    }
    
    // Fallback: Check banner data attribute (only if HTML lang doesn't work)
    const bannerElement = document.querySelector('.free-shipping-banner');
    if (bannerElement) {
        const isSwedishAttr = bannerElement.getAttribute('data-is-swedish');
        if (isSwedishAttr === 'true' && thresholdData?.sek) {
            return thresholdData.sek;
        }
    }
    
    if (!thresholdData) {
        return 399; // Default fallback
    } 
    // Fallback to DKK if available
    else if (thresholdData.dkk) {
        return thresholdData.dkk; // Default to DKK
    } 
    // Fallback to fallback value
    else if (thresholdData.fallback) {
        return thresholdData.fallback;
    }
    return 399;
}

function getCurrencyFromLang() {
    const htmlLang = document.documentElement.getAttribute('lang');
    const htmlLangLower = htmlLang ? htmlLang.toLowerCase() : '';
    return (htmlLangLower === 'sv' || htmlLangLower.startsWith('sv-')) ? 'SEK' : 'KR';
}

function forceUpdateBannerText() {
    // Force update the banner text based on current lang, regardless of what Liquid rendered
    const bannerElement = document.querySelector('.free-shipping-banner');
    if (!bannerElement) return;
    
    const htmlLang = document.documentElement.getAttribute('lang');
    const htmlLangLower = htmlLang ? htmlLang.toLowerCase() : '';
    const htmlLangCheck = htmlLangLower ? htmlLangLower.slice(0, 2) : '';
    
    const thresholdData = window.free_shipping_threshold;
    if (!thresholdData) return;
    
    const isSwedish = htmlLangCheck === 'sv';
    const freeShipping = isSwedish ? thresholdData.sek : thresholdData.dkk;
    
    if (!freeShipping) return;
    
    // Get cart total
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartTotal = data.total_price / 100;
            const threshold = Math.max(freeShipping - cartTotal, 0);
            const currencySymbol = isSwedish ? 'SEK' : 'KR';
            const displayText = `${threshold.toFixed(2).replace(".", ",")} ${currencySymbol}`;
            
            // Update the price element if it exists
            const priceElement = bannerElement.querySelector('.free-shipping-banner__price');
            if (priceElement) {
                priceElement.textContent = displayText;
            } else {
                // Fallback: update entire text
                const textElement = bannerElement.querySelector('.free-shipping-banner__text');
                if (textElement) {
                    const currentText = textElement.innerHTML || textElement.textContent;
                    const updatedText = currentText.replace(/\d+[.,]\d+\s*(KR|kr|SEK|sek)/g, displayText);
                    if (updatedText !== currentText) {
                        textElement.innerHTML = updatedText;
                    }
                }
            }
        })
        .catch(() => {});
}

function updateFreeShippingBanner(totalPrice) {
    const freeShipping = getFreeShippingThreshold();
    const cartTotal = totalPrice / 100; // Convert from cents to base currency
    const threshold = Math.max(freeShipping - cartTotal, 0);
    const progress = Math.min(Math.round((cartTotal / freeShipping) * 100), 100); // Clamp to max 100%

    const bannerElement = document.querySelector('.free-shipping-banner');
    if (!bannerElement) {
        return;
    }

    const bannerTexts = bannerElement.querySelectorAll('.free-shipping-banner__text');
    const priceElement = bannerElement.querySelector('.free-shipping-banner__price');
    const progressBar = bannerElement.querySelector('.free-shipping-banner__progress-bar');

    if (threshold > 0) {
        // Show "Spend more to get free shipping" message
        const currencySymbol = getCurrencyFromLang();
        const displayText = `${threshold.toFixed(2).replace(".", ",")} ${currencySymbol}`;
        
        // Update the price element if it exists
        if (priceElement) {
            priceElement.textContent = displayText;
        } else {
            // Fallback: try to update the entire text content if priceElement doesn't exist
            if (bannerTexts.length > 0) {
                const textElement = bannerTexts[0];
                const currentText = textElement.innerHTML || textElement.textContent;
                
                // Try to replace the amount in the text
                // Pattern: "67,11 KR" or "67,11 kr" or any number followed by KR/kr
                const updatedText = currentText.replace(/\d+[.,]\d+\s*(KR|kr|SEK|sek)/g, displayText);
                if (updatedText !== currentText) {
                    textElement.innerHTML = updatedText;
                } else {
                    // If no match, try to find and replace just the number
                    const numberPattern = /\d+[.,]\d+/;
                    const updatedText2 = currentText.replace(numberPattern, threshold.toFixed(2).replace(".", ","));
                    if (updatedText2 !== currentText) {
                        // Also need to add currency symbol
                        const finalText = updatedText2.replace(/(\d+[.,]\d+)/, displayText);
                        textElement.innerHTML = finalText;
                    }
                }
            }
        }
        
        if (progressBar) {
            progressBar.style.width = `${progress}%`;
        }

        if (bannerTexts.length >= 2) {
            bannerTexts[0].classList.remove('hide'); // "Spend more" message
            bannerTexts[1].classList.add('hide'); // "Free shipping achieved" message
        }
    } else {
        // Show "You have free shipping" message
        if (progressBar) {
            progressBar.style.width = `100%`;
        }

        if (bannerTexts.length >= 2) {
            bannerTexts[0].classList.add('hide'); // "Spend more" message
            bannerTexts[1].classList.remove('hide'); // "Free shipping achieved" message
        }
    }
}

function fetchCartAndUpdate() {
    fetch('/cart.js')
        .then((response) => {
            if (!response.ok) throw new Error('Failed to fetch cart data');
            return response.json();
        })
        .then((data) => {
            updateFreeShippingBanner(data.total_price);
        })
        .catch(() => {});
}

// Override fetch to monitor cart updates
const originalFetch = window.fetch;
window.fetch = async function (input, init) {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input.url;
    const cartUpdateEndpoints = [
        '/cart/change',
        '/cart/change.js',
        '/cart/add',
        '/cart/add.js',
        '/cart?section_id=cart-drawer'
    ];

    if (url && cartUpdateEndpoints.some(endpoint => url.includes(endpoint))) {
        try {
            response.clone().json().then((data) => {
                if (data?.total_price !== undefined) {
                    setTimeout(() => updateFreeShippingBanner(data.total_price), 400);
                } else if (data?.price !== undefined && data?.quantity !== undefined) {
                    setTimeout(fetchCartAndUpdate, 400);
                }
            });
        } catch (error) {
            // Silently fail
        }
    }

    return response;
};

document.addEventListener('click', (event) => {
    if (event.target.tagName === 'BUTTON' || event.target.classList.contains('m-cart-item__remove')) {
        setTimeout(fetchCartAndUpdate, 400);
    }
});

// Wait for DOM and threshold data to be ready
function initializeFreeShipping() {
    // Wait for window.free_shipping_threshold to be available (it's in a defer script)
    if (window.free_shipping_threshold) {
        fetchCartAndUpdate();
        // Also force update to fix any Liquid rendering issues
        setTimeout(() => {
            forceUpdateBannerText();
        }, 500);
    } else {
        // Retry after a short delay if threshold not yet available
        setTimeout(() => {
            if (window.free_shipping_threshold) {
                fetchCartAndUpdate();
                setTimeout(() => {
                    forceUpdateBannerText();
                }, 500);
            } else {
                // Fallback: try anyway with default currency detection
                fetchCartAndUpdate();
            }
        }, 100);
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initializeFreeShipping();
    });
} else {
    initializeFreeShipping();
}

// Also listen for when the cart drawer is opened/re-rendered (after language change)
document.addEventListener('cart:updated', () => {
    setTimeout(fetchCartAndUpdate, 200);
});

// Listen for cart drawer updates
window.addEventListener('updateCartDrawer', () => {
    setTimeout(fetchCartAndUpdate, 500);
});

// Also listen for when cart-drawer-items updates (custom web component)
const cartDrawerObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
            const banner = document.querySelector('.free-shipping-banner');
            if (banner) {
                setTimeout(fetchCartAndUpdate, 300);
                break;
            }
        }
    }
});

// Observe the cart drawer for changes
const cartDrawer = document.querySelector('m-cart-drawer');
if (cartDrawer) {
    cartDrawerObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
    });
    
    // Also force update when cart drawer opens
    const originalOpen = cartDrawer.open;
    if (originalOpen) {
        cartDrawer.open = function(...args) {
            originalOpen.apply(this, args);
            setTimeout(() => {
                forceUpdateBannerText();
            }, 100);
        };
    }
}

// Store last known language to detect changes
let lastKnownLang = document.documentElement.getAttribute('lang');

// Check for language changes periodically (useful after page reload from language change)
function checkLanguageChange() {
    const currentLang = document.documentElement.getAttribute('lang');
    if (currentLang !== lastKnownLang) {
        lastKnownLang = currentLang;
        fetchCartAndUpdate();
    }
}

// Check for currency changes when free shipping banner is added/updated
const bannerObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1) { // Element node
                    if (node.classList && node.classList.contains('free-shipping-banner')) {
                        // Banner was added/updated, refresh
                        setTimeout(fetchCartAndUpdate, 100);
                    } else if (node.querySelector && node.querySelector('.free-shipping-banner')) {
                        // Banner is inside added node
                        setTimeout(fetchCartAndUpdate, 100);
                    }
                }
            }
        }
    }
    // Also check if language changed
    checkLanguageChange();
});

// Observe changes to the document (for when cart drawer content is updated)
if (document.body) {
    bannerObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Also check periodically (in case language changes after page load)
    // Check every 2 seconds for the first 10 seconds after page load, then stop
    let checkCount = 0;
    const maxChecks = 5;
    const languageCheckInterval = setInterval(() => {
        checkLanguageChange();
        checkCount++;
        if (checkCount >= maxChecks) {
            clearInterval(languageCheckInterval);
        }
    }, 2000);
}
